document.addEventListener('DOMContentLoaded', () => {

  // ======================
  // OPEN ALL SUBMENUS BY DEFAULT
  // ======================
  document.querySelectorAll('.drawer_menu_item').forEach(item => {
    const panel = item.querySelector(':scope > .drawer_submenu');
    const row = item.querySelector('.drawer_menu_row');

    if (panel) panel.classList.add('active');
    if (row) row.classList.add('active');
    item.classList.add('active');
  });

});

document.addEventListener('click', (e) => {

  // ======================
  // OPEN DRAWER
  // ======================
  const openBtn = e.target.closest('[data-drawer-open]');
  if (openBtn) {
    const target = openBtn.getAttribute('data-drawer-open');
    const drawer = document.querySelector(`[data-drawer="${target}"]`);

    if (!drawer) return;

    drawer.classList.add('active');
    drawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }

  // ======================
  // CLOSE DRAWER
  // ======================
  const closeBtn = e.target.closest('[data-drawer-close]');
  const overlay = e.target.closest('[data-drawer-overlay]');

  if (closeBtn || overlay) {
    const drawer = (closeBtn || overlay).closest('[data-drawer]');
    if (!drawer) return;

    drawer.classList.remove('active');
    drawer.removeAttribute('open');

    document.body.style.overflow = '';
  }

  // ======================
  // SUBMENU TOGGLE (still works but starts OPEN)
  // ======================
  const row = e.target.closest('.drawer_menu_row');
  if (row) {
    const parent = row.closest('.drawer_menu_item');
    const panel = parent?.querySelector(':scope > .drawer_submenu');

    if (!panel) return;

    const isOpen = parent.classList.contains('active');

    panel.classList.toggle('active', !isOpen);
    parent.classList.toggle('active', !isOpen);
    row.classList.toggle('active', !isOpen);
  }

});

// ======================
// ESC CLOSE ALL DRAWERS
// ======================
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('[data-drawer]').forEach(drawer => {
      drawer.classList.remove('active');
      drawer.removeAttribute('open');
    });
    document.body.style.overflow = '';
  }
});


//   frist 2 menu open

//   document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.drawer_menu_item').forEach((item, index) => {
//     if (index < 2) {
//       const panel = item.querySelector(':scope > .drawer_submenu');
//       const row = item.querySelector('.drawer_menu_row');

//       panel?.classList.add('active');
//       row?.classList.add('active');
//       item.classList.add('active');
//     }
//   });
// });